import {
  filterProducts,
  findProducts,
  getProductsByStoreID,
} from "../../utils/ApiCalls";
import { INDEX_STATE } from "../../utils/constants";

const initState = {
  pageCount: 0,
  products: [],
  indexState: "",
  slug: "",
  index: 1,
  loading: false,
  loadMore: false,
  searchField: "",
};

const reducers = {
  add(state, payload) {
    return {
      ...state,
      products: [...state.products, ...payload.products],
      indexState: payload.indexState,
      index: (state.index += 1),
      loading: false,
    };
  },
  setSlug(state, payload) {
    return { ...state, slug: payload, index: 1 };
  },
  setLoading(state, payload) {
    return { ...state, loading: payload };
  },
  set(state, payload) {
    return { ...state, ...payload, index: 1, loading: false };
  },
  changeIndexState(state, payload) {
    return { ...state, indexState: payload, index: 1 };
  },
  setFirstRenderTrue(state) {
    return { ...state, firstRender: true };
  },
  setSearchField(state, payload) {
    return { ...state, searchField: payload };
  },
};

export const products = {
  state: initState,
  reducers: reducers,
  effects: (dispatch) => ({
    async filter(payload, state) {
      try {
        dispatch.loading.show();
        let { index, indexState } = state.products;
        let { loadMore } = payload;
        let { firstRender } = state;

        //If User changes type to fetching Products
        if (!firstRender && !loadMore) {
          index = 1;

          let response = await filterProducts({ ...payload, index });

          dispatch.products.set({
            ...response,
            indexState: INDEX_STATE.FILTER,
          });
          dispatch.loading.hide();
          dispatch.firstRender.false();
          return;
        }
      } catch (e) {
        dispatch.loading.error();
      }
    },
    async getProducts(payload, state) {
      try {
        dispatch.loading.show();
        let { index, indexState } = state.products;
        let { loadMore } = payload;
        let { firstRender } = state;

        //If Page is reloaded
        if (firstRender && !loadMore && indexState === INDEX_STATE.ALL) {
          dispatch.loading.hide();
          dispatch.firstRender.false();
          return;
        }

        //If Page is first loaded
        if (firstRender || indexState === "") {
          console.log("first load");

          index = 1;
          let response = await getProductsByStoreID({ ...payload, index });

          dispatch.products.set({
            ...response,
            indexState: INDEX_STATE.ALL,
          });
          dispatch.loading.hide();
          dispatch.firstRender.false();
          return;
        }

        //If User changes type to Getting Products
        if (!firstRender && !loadMore && indexState !== INDEX_STATE.ALL) {
          console.log("change to get products");

          index = 1;

          let response = await getProductsByStoreID({ ...payload, index });

          dispatch.products.set({
            ...response,
            indexState: INDEX_STATE.ALL,
          });
          dispatch.loading.hide();
          dispatch.firstRender.false();
          return;
        }
      } catch (e) {
        dispatch.loading.error();
      }
    },
    async searchProducts(payload, state) {
      try {
        dispatch.loading.show();
        let { index, indexState } = state.products;
        let { loadMore } = payload;
        let { firstRender } = state;

        //If Page is first loaded or If user searches again
        if (
          firstRender ||
          indexState === "" ||
          state.products.searchField !==
            `${payload.searchString}_${payload.category}`
        ) {
          index = 1;
          let response = await findProducts({ ...payload, index });

          dispatch.products.set({
            ...response,
            indexState: INDEX_STATE.SEARCH,
          });
          dispatch.products.setSearchField(
            `${payload.searchString}_${payload.category}`
          );
          dispatch.loading.hide();
          dispatch.firstRender.false();
          return;
        }

        //If Page is reloaded
        if (firstRender && !loadMore && indexState === INDEX_STATE.SEARCH) {
          dispatch.loading.hide();
          dispatch.firstRender.false();
          return;
        }

        //If User changes type to Getting Products
        if (!firstRender && !loadMore && indexState !== INDEX_STATE.SEARCH) {
          index = 1;

          let response = await findProducts({ ...payload, index });

          dispatch.products.set({
            ...response,
            indexState: INDEX_STATE.SEARCH,
          });
          dispatch.loading.hide();
          dispatch.firstRender.false();
          return;
        }
      } catch (e) {
        dispatch.loading.error();
      }
    },
    async loadMoreProducts(payload, state) {
      let { index } = state.products;

      if (state.products.indexState === INDEX_STATE.ALL) {
        console.log("all");
        index += 1;
        let response = await getProductsByStoreID({ ...payload, index });

        dispatch.products.add({
          ...response,
          indexState: INDEX_STATE.ALL,
        });
        dispatch.loading.hide();
        dispatch.firstRender.false();

        return;
      }

      if (state.products.indexState === INDEX_STATE.FILTER) {
        index = index + 1;
        console.log("filter");
        let response = await filterProducts({ ...payload, index });

        dispatch.products.add({
          ...response,
          indexState: INDEX_STATE.FILTER,
        });
        dispatch.loading.hide();
        dispatch.firstRender.false();

        return;
      }

      if (state.products.indexState === INDEX_STATE.SEARCH) {
        console.log("search");
        index += 1;
        let response = await findProducts({ ...payload, index });

        dispatch.products.add({
          ...response,
          indexState: INDEX_STATE.SEARCH,
        });
        dispatch.loading.hide();
        dispatch.firstRender.false();

        return;
      }
    },
  }),
};
